// extracted by mini-css-extract-plugin
export default {"statsContainer":"styles_statsContainer__Si3Kc","resultsStats":"styles_resultsStats__M5wy-"};